var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15903 14.9905L5.07899 5.31836H9.30105L10.0761 13.4577M2 21.9991H21.9992V11.6437C21.999 11.4932 21.9643 11.3447 21.898 11.2096C21.8316 11.0745 21.7353 10.9564 21.6163 10.8643C21.4973 10.7722 21.3589 10.7085 21.2116 10.6782C21.0643 10.6478 20.912 10.6516 20.7664 10.6891L2.66664 15.3802C2.4759 15.4297 2.307 15.5413 2.18649 15.6973C2.06598 15.8533 2.00069 16.045 2.00089 16.2423L2 21.9991Z",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1921 8.80791C14.5096 10.1254 16.6857 10.086 18.0521 8.71963C19.7952 6.97649 20.0145 4.29486 19.9993 2.92283C19.9993 2.67825 19.9021 2.44369 19.7292 2.27075C19.5563 2.09781 19.3217 2.00065 19.0771 2.00065C17.7051 1.98603 15.0241 2.20477 13.2804 3.94791C11.914 5.31431 11.8746 7.49043 13.1921 8.80791ZM13.1921 8.80791L12 10M13.1921 8.80791L16.373 5.62696M17.5657 4.43431L16.3736 5.62639L17.5657 6.02451M16.3736 5.62696L15.9755 4.43431M15.9755 7.6147L15.3159 7.3954C15.1502 7.3402 14.9997 7.24718 14.8763 7.12371C14.7528 7.00025 14.6598 6.84973 14.6046 6.68409L14.3853 6.02451",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3322 18.441H9.99896M6.88797 18.441H5.55469M18.8875 22.0005H14.4432V17.9971C14.4432 17.7611 14.5369 17.5348 14.7036 17.368C14.8703 17.2012 15.0963 17.1074 15.3321 17.1074H17.9986C18.2344 17.1074 18.4605 17.2012 18.6272 17.368C18.7939 17.5348 18.8875 17.7611 18.8875 17.9971V22.0005Z",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgCollapseIcon);
export default __webpack_public_path__ + "static/media/ESGCollapseIcon.447b8e85703bb151cfe85ba2241e1f3e.svg";
export { ForwardRef as ReactComponent };